import classes from './fieldByType.module.css';

import WidgetSwitchVariants from 'components/Widgets/WidgetSwitchVariants';

const SwitchVariantTypeField = ({ item, selectItem, setNewSelectItem, disabled, forTable }) => {
  const handleChange = (val) => {
    const newValue = {
      value: val.param ?? ' ',
      setting: { name: val.param, value: val.value },
    };
    setNewSelectItem(newValue);
  };

  if (forTable) {
    const value =
      typeof item.value === 'string' ? item.value : item.value?.setting?.name || item.value?.value;
    return (
      <div
        style={{
          fontSize: '15px',
          lineHeight: 1.4,
          fontWeight: 800,
        }}
      >
        {value}
      </div>
    );
  } else {
    return (
      <WidgetSwitchVariants
        key={item?.id}
        className={classes.widgetSwitchVariants}
        item={item}
        current={selectItem?.setting}
        onChange={handleChange}
        disabled={disabled}
      />
    );
  }
};

export default SwitchVariantTypeField;
